var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"file-select"},[_c('div',{staticClass:"button"},[(_vm.value)?_c('span',[_vm._v("Archivo seleccionado: "+_vm._s(_vm.value.name))]):_c('span',[_vm._v("Adjuntar archivo")])]),_vm._v(" "),_c('input',{attrs:{"type":"file"},on:{"change":_vm.handleFileChange}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a6fbd26","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Formulario/FileSelect.vue
// module id = null
// module chunks = 